(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  class StickyNav {
    constructor() {
      this.mainMenu = document.querySelector('.main-menu');
      this.lastScrollTop = 0;
      this.init();
    }

    init() {
      if (!this.mainMenu) return;
      
      // Initialize observer for header height changes
      this.observeHeaderHeight();
      
      // Add scroll event listener
      window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    observeHeaderHeight() {
      // Get header element
      const header = document.querySelector('.header');
      if (!header) return;

      // Create observer to watch for height changes
      const observer = new ResizeObserver(entries => {
        for (let entry of entries) {
          const headerHeight = entry.borderBoxSize[0].blockSize;
          this.mainMenu.style.setProperty('--header-height', `${headerHeight}px`);
        }
      });

      observer.observe(header);
    }

    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isScrollingDown = scrollTop > this.lastScrollTop;
      
      // Add or remove sticky class based on scroll position
      if (scrollTop > 0) {
        this.mainMenu.classList.add('is-sticky');
      } else {
        this.mainMenu.classList.remove('is-sticky');
      }

      this.lastScrollTop = scrollTop;
    }
  }

  // Initialize sticky nav
  customElements.whenDefined('store-header').then(() => {
    new StickyNav();
  });

  } catch(e) { console.error(e); }
})();
})();
